import Chart from 'chart.js';
import { merge } from 'lodash';

import './chart.style.sass';
import template from './chart.tpl.pug';

merge(Chart.defaults.global, {
    legend: {
        display: false
    },
    hover: {
        mode: 'index',
        intersect: false
    },
    tooltips: {
        position: 'average',
        mode: 'index',
        intersect: false,
        backgroundColor: '#fff',
        borderWidth: 1,
        borderColor: '#ebeced',
        xPadding: 15,
        yPadding: 15,
        titleFontStyle: 'bold',
        titleFontColor: '#394852',
        titleMarginBottom: 13,
        bodyFontStyle: 'normal',
        bodySpacing: 10,
        displayColors: false,
        caretSize: 8,
        caretPadding: 10,
        cornerRadius: 4
    },
    defaultFontFamily: `'Open Sans', sans-serif`,
    defaultFontSize: 14
});

class ChartController {
    /* @ngInject */
    constructor($q, $element) {
        this.$q = $q;
        this.$element = $element;

        this.chartPromise = this.$q.defer();
    }

    $onChanges(changeObject) {
        if (changeObject.data && this.data) {
            this.getChart().then((chart) => this.updateData(chart, this.data));
        }

        if (changeObject.options && this.options) {
            this.getChart().then((chart) => this.updateOptions(chart, this.options));
        }
    }
    
    $postLink() {
        let context = this.$element.children()[0];

        this.chartPromise.resolve(new Chart(context, {
            type: this.type,
            options: this.options || {}
        }));
    }

    getChart() {
        return this.chartPromise.promise;
    }

    updateData(chart, data) {
        let { labels, datasets } = data;

        chart.data.labels = labels;
        chart.data.datasets = datasets;
        chart.update();
    }

    updateOptions(chart, options) {
        merge(chart.options, options || {});
        chart.update();
    }
}

export default {
    selector: 'dbAChart',
    template: template(),
    controller: ChartController,
    bindings: {
        type: '@',
        options: '<',
        data: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/dashboard/component/chart/chart.cmpt.js